import { styled } from '@mui/material/styles'

export const LegendsContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`
